import { useMutation } from '@tanstack/vue-query'

type Phone = { number: number; country?: { phone_code?: string } }

export const useVerifyOTP = () => {
  return useMutation({
    mutationFn: async ({ phone, code }: { phone: Phone; code: string }) => {
      const fullPhone = `${phone.country?.phone_code || ''}${phone.number}`
      return await $fetch('/api/verify/verify-otp', {
        method: 'POST',
        body: { phone: fullPhone, code },
      })
    },
  })
}